<template>
    <article>
        <h1>Add a new recipe</h1>
        <form class="form--recipe" @submit.prevent>
            <section class="form__section">
                <ImageUpload :imageName="imageName" @updateImageData="updateImage"></ImageUpload>
                <p>
                    <input
                        id="recipe-name"
                        name="recipe-name"
                        ref="recipeName"
                        type="text"
                        v-model="name"
                        class="input input--h1"
                    />
                    <label for="recipe-name">
                        <span>Recipe Name</span>
                    </label>
                </p>
                <p>
                    <input
                        id="recipe-prepTime"
                        name="recipe-prepTime"
                        type="number"
                        v-model="prepTime"
                        class="input input--text"
                    />
                    <label for="recipe-prepTime">
                        <span>Prep Time (in minutes)</span>
                    </label>
                </p>
                <p>
                    <input
                        id="recipe-cookTime"
                        name="recipe-cookTime"
                        type="number"
                        v-model="cookTime"
                        class="input input--text"
                    />
                    <label for="recipe-cookTime">
                        <span>Cook Time (in minutes)</span>
                    </label>
                </p>
                <!--<p>{{ getIngredientsLength(recipe.sections) }} Ingredients</p>-->
                <p>
                    <input
                        id="recipe-servings"
                        name="recipe-servings"
                        type="number"
                        v-model="servings"
                        class="input input--text"
                    />
                    <label for="recipe-servings">
                        <span>Servings</span>
                    </label>
                </p>
            </section>

            <!-- INGREDIENTS -->
            <section class="form__section">
                <h2>Ingredients</h2>
                <div
                    class="ingredients form__subsection"
                    v-for="(section, sectionId, sectionIndex) in newSections"
                    :key="section.id"
                >
                    <div class="form__row" v-show="!sectionTitles[sectionIndex].addTitle">
                        <button
                            type="button"
                            class="button button--add-new button--add-note"
                            @click="showSectionTitleField(sectionIndex)"
                        >+ Section Title</button>
                    </div>
                    <div class="form__row" v-show="sectionTitles[sectionIndex].addTitle">
                        <input
                            type="text"
                            class="input no-margin"
                            :name="`ingredientSectionTitle${sectionId}`"
                            v-model="newSections[sectionId].sectionTitle"
                        />
                        <label :for="`ingredientSectionTitle${sectionId}`">
                            <span>Section Title</span>
                        </label>
                    </div>
                    <div
                        class="form__row ingredient flex flex--ingredient"
                        v-for="(ingredient, ingredientIndex) in newSections[sectionId].ingredients"
                        :key="ingredient.id"
                    >
                        <!--<p>Ingredient {{ ingredientIndex + 1 }}</p>-->
                        <div class="flex__item ingredient__amount">
                            <input
                                type="text"
                                class="input input--text"
                                :name="`ingredientAmount${ingredient}`"
                                v-model="newIngredients[ingredient].amount"
                            />
                            <label :for="`ingredientAmount${ingredient}`">
                                <span>Amount</span>
                            </label>
                        </div>
                        <div class="flex__item ingredient__name">
                            <input
                                type="text"
                                class="input input--text"
                                :name="`ingredientName${ingredient}`"
                                v-model="newIngredients[ingredient].name"
                            />
                            <label :for="`ingredientName${ingredient}`">
                                <span>Name</span>
                            </label>
                        </div>
                        <div
                            class="flex__item ingredient__add-note"
                            v-show="!ingredientNotes[ingredientIndex].addNote"
                        >
                            <button
                                type="button"
                                class="button button--add-new"
                                @click="showNoteField(ingredientNotes, ingredientIndex)"
                            >+ Note</button>
                        </div>
                        <div
                            class="flex__item ingredient__note"
                            v-show="ingredientNotes[ingredientIndex].addNote"
                        >
                            <textarea
                                rows="1"
                                class="input input--text"
                                :name="`ingredientNote${ingredient}`"
                                v-model="newIngredients[ingredient].note"
                            ></textarea>
                            <label :for="`ingredientNote${ingredient}`">
                                <span>Note</span>
                            </label>
                        </div>
                        <div
                            class="flex__item ingredient__remove"
                            v-if="newSections[sectionId].ingredients.length > 1"
                        >
                            <button
                                type="button"
                                class="button button--remove"
                                @click="removeIngredient(ingredient, ingredientIndex, sectionId)"
                            >&times;</button>
                        </div>
                    </div>
                    <div class="form__row">
                        <button
                            type="button"
                            class="button button--add-new"
                            @click="addNewIngredient(sectionId)"
                        >+ Ingredient</button>
                    </div>
                    <div class="form__row align-center" v-if="sectionIds.length > 1">
                        <button
                            type="button"
                            class="button button--remove button--remove-section"
                            @click="removeSection(sectionId, sectionIndex)"
                        >Remove section</button>
                    </div>
                </div>
                <div class="align-center">
                    <button
                        type="button"
                        class="button button--add-new-section"
                        @click="addNewSection()"
                    >Add Another Section</button>
                </div>
            </section>

            <!-- DIRECTIONS -->
            <section class="form__section">
                <h2>Directions</h2>
                <div
                    class="directions form__subsection"
                    v-for="(section, sectionId, sectionIndex) in newSections"
                    :key="section.id"
                >
                    <div class="form__row" v-show="!sectionTitles[sectionIndex].addTitle">
                        <button
                            type="button"
                            class="button button--add-new button--add-note"
                            @click="showSectionTitleField(sectionIndex)"
                        >+ Section Title</button>
                    </div>
                    <div class="form__row" v-show="sectionTitles[sectionIndex].addTitle">
                        <input
                            type="text"
                            class="input input--text"
                            :name="`directionSectionTitle${sectionId}`"
                            v-model="newSections[sectionId].sectionTitle"
                        />
                        <label :for="`directionSectionTitle${sectionId}`">
                            <span>Section Title</span>
                        </label>
                    </div>
                    <div class="form__row" v-if="newSections[sectionId] !== ''">
                        <button
                            type="button"
                            v-show="!sectionNotes[sectionIndex].addNote"
                            class="button button--add-new button--add-note"
                            @click="showNoteField(sectionNotes, sectionIndex)"
                        >+ Section Note</button>
                        <div
                            class="input--section-note"
                            v-show="sectionNotes[sectionIndex].addNote"
                        >
                            <textarea
                                rows="1"
                                v-model="section.sectionNote"
                                class="input input--text"
                            ></textarea>
                            <label for="`directionSectionNote${note}`">
                                <span>Section Note</span>
                            </label>
                        </div>
                    </div>
                    <div
                        class="form__row direction flex flex--direction"
                        v-for="(direction, directionIndex) in newSections[sectionId].directions"
                        :key="direction.id"
                    >
                        <div class="flex__item direction__number">{{ directionIndex + 1 }}.</div>
                        <div class="flex__item direction__info flex">
                            <div class="flex__item direction__input">
                                <textarea
                                    class="input input--text input--direction"
                                    :name="`directionName${direction}`"
                                    v-model="newDirections[direction].direction"
                                ></textarea>
                                <label :for="`directionName${direction}`">
                                    <span>Direction</span>
                                </label>
                            </div>
                            <div
                                class="flex__item direction__add-note"
                                v-show="!directionNotes[directionIndex].addNote"
                            >
                                <button
                                    type="button"
                                    class="button button--add-new"
                                    @click="showNoteField(directionNotes, directionIndex)"
                                >+ Note</button>
                            </div>
                            <div
                                class="flex__item direction__note"
                                v-show="directionNotes[directionIndex].addNote"
                            >
                                <textarea
                                    rows="1"
                                    class="input input--text"
                                    :name="`directionNote${direction}`"
                                    v-model="newDirections[direction].note"
                                ></textarea>
                                <label :for="`directionNote${direction}`">
                                    <span>Note</span>
                                </label>
                            </div>
                            <div
                                class="flex__item ingredient__remove"
                                v-if="newSections[sectionId].directions.length > 1"
                            >
                                <button
                                    type="button"
                                    class="button button--remove"
                                    @click="removeDirection(direction, directionIndex, sectionId)"
                                >&times;</button>
                            </div>
                        </div>
                    </div>
                    <div class="form__row direction flex flex--direction">
                        <div
                            class="flex__item direction__number direction__number--next"
                        >{{ section.directions.length + 1 }}.</div>
                        <div class="flex__item direction__info flex">
                            <button
                                type="button"
                                class="button button--add-new"
                                @click="addNewDirection(sectionId)"
                            >+ Direction</button>
                        </div>
                    </div>
                    <div class="form__row align-center" v-if="sectionIds.length > 1">
                        <button
                            type="button"
                            class="button button--remove button--remove-section"
                            @click="removeSection(sectionId, sectionIndex)"
                        >Remove section</button>
                    </div>
                </div>
                <div class="align-center">
                    <button
                        type="button"
                        class="button button--add-new-section"
                        @click="addNewSection()"
                    >Add Another Section</button>
                </div>
            </section>
            <div class="align-center">
                <button type="button" class="button button--cancel" @click="cancelEdit">Cancel</button>
                <button type="submit" class="button button--save" @click="saveRecipe">Save Recipe</button>
            </div>
        </form>
    </article>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
//import vueDropzone from "vue2-dropzone";
import ImageUpload from "@/components/ImageUpload.vue";
//import firebase from "firebase";
export default {
    data() {
        return {
            urlId: "",
            name: "",
            prepTime: 0,
            cookTime: 0,
            servings: 0,
            imageName: "",
            details: [],
            sectionIds: [],
            newSections: {},
            newIngredients: {},
            newDirections: {},
            sectionTitles: [],
            ingredientNotes: [],
            directionNotes: [],
            sectionNotes: []
            /*dropOptions: {
                url:
                    "https://us-central1-recipe-app-475a9.cloudfunctions.net/uploadFile",
                maxFiles: 1,
                addRemoveLinks: true
            },*/
        };
    },

    components: {
        //vueDropzone
        ImageUpload
    },

    created() {
        this.addNewSection();
    },

    computed: {
        ...mapGetters([
            "recipes",
            "sections",
            "ingredients",
            "directions",
            "getCurrentUser"
        ]),
        /*recipe() {
            const id = this.urlId;
            if (!id) {
                this.createNewRecipe();
                return;
            }
            return this.$store.getters.recipeById(id);
        },*/
        recipeSections() {
            let sectionIds = this.recipe.sections; // [ 0, 1 ]
            let sectionArray = [];

            sectionIds.forEach(section => {
                sectionArray.push(this.sections[section]);
            });

            return sectionArray;
        }
    },

    methods: {
        ...mapActions(["addRecipe", "updateRecipe"]),
        createNewRecipe() {
            let newRecipe = {
                name: this.name,
                id: this.createUniqueId(this.recipes),
                urlId: this.encodeRecipeName(this.name),
                origDate: this.getNewDate(),
                lastUpdated: this.getNewDate(),
                prepTime: this.prepTime,
                cookTime: this.cookTime,
                servings: this.servings,
                imageName: this.imageName,
                sectionIds: this.sectionIds,
                categories: [],
                details: [],
                author: this.getCurrentUser.uid
            };

            let newSections = this.newSections;

            let newIngredients = JSON.parse(
                JSON.stringify(this.newIngredients)
            );

            let newDirections = JSON.parse(JSON.stringify(this.newDirections));

            let userId = this.getCurrentUser.id;

            this.addRecipe({
                newRecipe,
                newSections,
                newIngredients,
                newDirections,
                userId
            });

            console.log("new recipe: ", newRecipe);
            console.log("new sections: ", newSections);
            console.log("new Ingredients: ", newIngredients);
            console.log("new directions: ", newDirections);

            this.$router.push({
                name: "recipe",
                params: { id: newRecipe.urlId }
            });
        },
        saveRecipe() {
            // save recipe here, then navigate to recipe page
            this.createNewRecipe();
        },
        cancelEdit() {
            if (confirm("Do you want to cancel adding this recipe?")) {
                //this.toggleEditStatus();
                this.$router.replace({
                    name: "home"
                });
            }
        },
        /*removeImage() {
            this.imageName = "";
            this.imageUrl = "";
        },
        getImage() {
            let imageName = this.recipe.imageName;
            let self = this;
            console.log(imageName);
            let storageRef = firebase.storage().ref();
            let pathReference = storageRef.child(imageName);
            console.log(storageRef, pathReference);

            pathReference.getDownloadURL().then(function(url) {
                console.log(url);
                self.imageUrl = url;
            });
        },*/
        /*deleteImage() {
            const imageName = this.imageName;
            let storageRef = firebase.storage().ref();
            let pathReference = storageRef.child(imageName);

            pathReference
                .delete()
                .then(function() {
                    console.log("deteled image");
                })
                .catch(function(error) {
                    console.log("ERROR: could not delete image", error);
                });
        },*/
        addNewSection() {
            const sectionId = this.createUniqueId(this.sectionIds);
            const newSection = {
                id: sectionId,
                sectionTitle: "",
                ingredients: [],
                directions: [],
                sectionNote: ""
            };

            this.sectionTitles.push({ addTitle: false });
            this.sectionNotes.push({ addNote: false });

            // make the object reactive by using Vue.set(), not necessary with an array
            // also not necessary for ingredients or directions because of how I'm accessing them (looping through an array of IDs to then access that specific one)
            Vue.set(this.newSections, sectionId, newSection);

            this.sectionIds.push(sectionId);
            this.addNewIngredient(sectionId);
            this.addNewDirection(sectionId);
        },
        addNewIngredient(sectionId) {
            const ingredientId = this.createUniqueId(this.newIngredients);

            this.newIngredients[ingredientId] = {
                id: ingredientId,
                amount: "",
                name: "",
                note: "",
                recipeId: this.id
            };

            this.ingredientNotes.push({ addNote: false });

            this.newSections[sectionId].ingredients.push(ingredientId);
        },
        addNewDirection(sectionId) {
            const directionId = this.createUniqueId(this.newDirections);

            this.newDirections[directionId] = {
                id: directionId,
                direction: "",
                note: "",
                recipeId: this.id
            };

            this.directionNotes.push({ addNote: false });

            this.newSections[sectionId].directions.push(directionId);
        },
        removeSection(sectionId, sectionIndex) {
            var self = this;
            // remove all the ingredients and directions that were added
            this.newSections[sectionId].ingredients.forEach(
                (ingredient, ingredientIndex) => {
                    this.removeIngredient(
                        ingredient,
                        ingredientIndex,
                        this.sectionIds[sectionIndex]
                    );
                }
            );

            this.newSections[sectionId].directions.forEach(
                (direction, directionIndex) => {
                    this.removeDirection(
                        direction,
                        directionIndex,
                        this.sectionIds[sectionIndex]
                    );
                }
            );

            this.sectionIds.splice(sectionIndex, 1);

            // remove the section
            Vue.delete(self.newSections, sectionId);

            self.sectionNotes.splice(sectionIndex, 1);
            console.log(this.sectionIds, this.newSections, this.sectionNotes);
        },
        removeIngredient(ingredientId, ingredientIndex, sectionId) {
            console.log(1, ingredientId, ingredientIndex, sectionId);
            this.newSections[sectionId].ingredients.splice(ingredientIndex, 1);
            this.ingredientNotes.splice(ingredientIndex, 1);
            delete this.newIngredients.ingredientId;
            console.log(2, ingredientId, ingredientIndex, sectionId);
        },
        removeDirection(directionId, directionIndex, sectionId) {
            console.log(1, directionId, directionIndex, sectionId);
            this.newSections[sectionId].directions.splice(directionIndex, 1);
            this.directionNotes.splice(directionIndex, 1);
            delete this.newDirections.directionId;
            console.log(1, directionId, directionIndex, sectionId);
        },
        createUniqueId(array) {
            return array && Date.now() === array[array.length - 1]
                ? (Date.now() + array.length).toString()
                : Date.now().toString();
        },
        encodeRecipeName(str) {
            str = str.replace(/\W+(?!$)/g, "-").toLowerCase();
            str = str.replace(/\W$/, "").toLowerCase();

            return str;
        },
        getNewDate() {
            const date = new Date();
            return date.toDateString();
        },
        showNoteField(array, index) {
            array[index].addNote = true;
        },
        showSectionTitleField(index) {
            this.sectionTitles[index].addTitle = true;
        },
        updateImage(imageName) {
            this.imageName = imageName;
        }
    }
};
</script>

